export default "__VITE_ASSET__UUpf7eyG__";